import React, { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Paper, Box, IconButton, TextField, Menu, MenuItem, Divider, InputAdornment, Button, Modal, Typography, ToggleButton, ToggleButtonGroup, Skeleton } from "@mui/material";
import { useOutletContext, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { esignToolApi } from "../../services/esignApi";
import { pdfToolApi } from "../../services/PdfEditor/pdfToolApi";
import { esignIcons } from "../Esign/icons";
import DocumentDetails from "./documnetDetails";
import { getStatusStyles } from "../../heplers";
import { toast } from "react-toastify"
import { uploadDocument, clearUploadedDocument, setUploadedDocument } from "../../store/reducers/uploadDocumentSlice";
import Loader from "../Loader";
import { fetchPdfEditorDetails, refreshToken } from "../../store/reducers/pdfEditorTokenSlice";
import { apiEndpoint } from "../../urls";
import { getEsignDocumentUrl, getPdfEditorDocumentUrl } from "../../utils/pdfUrl";
import PdfPreview from "../PdfPreview/pdfPreview";
import { debounce } from "lodash"; 
import { useLogger } from "../../hooks/useLogger";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const AllDocumentTable = () => {
  const logEvent = useLogger();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDetails, setOpenDetails] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [signersStatus, setSignersStatus] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [previewDoc, setPreviewDoc] = useState({});
  const { open } = useOutletContext();
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  const { profileData } = useSelector((state) => state.profile);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [tableloader, setTableLoader] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [selectedDetailDoc, setSelectedDetailDoc] = useState(null);
  const [filter, setFilter] = useState(false);
  const [status, setStatus] = useState('all');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    console.log("Updated previewDoc in parent:", previewDoc);
  }, [previewDoc]);

  useEffect(() => {
    if(!openDetails)
    {
      fetchAllDocuments(currentPage, rowsPerPage, searchText);
    }
  }, [currentPage, openDetails, rowsPerPage, searchText]);

  const fetchAllDocuments = async (page, rowsPerPage, searchText) => {
    setTableLoader(true)
    try {
      const response = await esignToolApi.getAllSentToEsignDocument(page, rowsPerPage, searchText);
      setTableLoader(false)
      if (response?.status) {
        // console.log(response)
        setDocuments(response?.data);
        setTotalPages(response?.pages);
        setTotalEntries(response?.total_records)
      }
    } catch (error) {
      setTableLoader(false)
      console.error("Error fetching data:", error);
    }
  };

  const handleChangePage = (_, newPage) => {
    if (newPage + 1 <= totalPages) {
      setCurrentPage(newPage + 1);
      fetchAllDocuments(newPage + 1, rowsPerPage, searchText);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleMenuOpen = (event, doc) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedDoc(doc);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedDoc(null);
  };

  const handleExpire = () => {
    console.log("Expire document:", selectedDoc?.document_id);
    handleMenuClose();
  };

  const handleNewRequest = async () => {
    logEvent('Clicked', 'New Request Clicked', 'Documents');
    if(pdfEditortoken?.access && selectedDoc?.document_id)
    {
      setLoader(true)
      console.log(selectedDoc);
      try {

        const checkPendingEsign = await esignToolApi.checkPendingEsign(
          selectedDoc.request_id,
          selectedDoc.document_id
        );
        console.log(checkPendingEsign)
  
        if (!checkPendingEsign.status) {
          console.error("checkPendingEsign:", checkPendingEsign);
          setLoader(false);
          return;
        }

        if (checkPendingEsign.status) {
          const response = await pdfToolApi.getSelectedDocuments(pdfEditortoken?.access, selectedDoc?.document_id, "");
          setLoader(false)
          if (response.status) {
            console.log(response)
            const documentUrl = getPdfEditorDocumentUrl(response?.data);

            if (!documentUrl) {
                console.error("Document URL not found in response.");
                return;
            }
            const checkResponse = await fetch(documentUrl, { method: 'GET' });
            if (!checkResponse.ok) {
                console.error(`Document not found: ${documentUrl}`);
                return;
            }


            const cloneSignerResponse = await esignToolApi.cloneSignerWithRequestId(
              selectedDoc.request_id,
              selectedDoc.document_id
            );
            console.log(cloneSignerResponse)
      
            if (!cloneSignerResponse.status) {
              console.error("Clone signer API failed:", cloneSignerResponse);
              setLoader(false);
              return;
            }
      
            console.log("Clone signer success:", cloneSignerResponse);
            // uploadFileFromUrl(documentUrl)
            // dispatch(clearUploadedDocument())
            // dispatch(setUploadedDocument(JSON.parse(localStorage.getItem("uploadedDocument"))));
            if (cloneSignerResponse.status) {
              const documentData = { data: response?.data, fullView: true };
              localStorage.setItem("uploadedDocument", JSON.stringify(documentData));
              navigate("/esign/pdfeditor", { replace: true }); 
            }
          }
        }
        else
        {
          toast.warning(checkPendingEsign?.message)
        }
      } catch (error) {
        setLoader(false)
        if (error.response?.status === 401 && error.response?.data?.code === "token_not_valid") {
          console.warn("Access token expired, attempting to refresh...");
          dispatch(refreshToken())
            .unwrap()
            .then((newTokenData) => {
              if (newTokenData.access) {
                handleNewRequest();
              }
            })
            .catch((refreshError) => {
              console.error("Token refresh failed, user may need to log in again.", refreshError);
            });
        } else {
          console.error("Error fetching documents:", error);
        }
      } 
    }
  };

  function uploadFileFromUrl(fileUrl, uploadEndpoint) {
    fetch(fileUrl)
      .then(response => response.blob())
      .then(blob => {
          const file = new File([blob], "uploadedFile.pdf", { type: blob.type });
          const formData = new FormData();
          dispatch(uploadDocument({ token: pdfEditortoken?.access, file }));
          navigate("/esign/new-esign", { replace: true });
      })
      .catch(error => console.error("Error fetching file:", error));
  }

  useEffect(() => {
    if (!menuAnchorEl && selectedDoc) {
      handlePreview(selectedDoc);
    }
  }, [selectedDoc, menuAnchorEl]);

  const handlePreview = async (selectedDoc) => {
    logEvent('Clicked', 'Preview Button Clicked', 'Documents');
    if(selectedDoc?.document_id && selectedDoc?.pdf_path)
    {
      setLoader(true)
      if(selectedDoc?.is_uploaded_to_s3)
      {
        console.log(selectedDoc)
        const payload = {
          "file_name": `${selectedDoc?.pdf_path}`
        };
        try {
          const response = await fetch(`${apiEndpoint.esignBaseUri}/EsignServices/download_pdf_file_from_s3`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });
  
          if (!response.ok) {
            setLoader(false);
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
      
          const data = await response.json();
          console.log(data)
          const documentUrl = getEsignDocumentUrl(data.url);

            if (!documentUrl) {
              setLoader(false);
              toast.info(`Not Found: document not found`);
              return;
            }
            const checkResponse = await fetch(documentUrl, { method: 'GET' });
            if (!checkResponse.ok) {
              setLoader(false);
              toast.info(`Not Found: document not found`);
              return;
            }
            var previewDocumnetData = {document_url: documentUrl, document_name: selectedDoc?.document_name}
            setPreviewDocument(true)
            setPreviewDoc(previewDocumnetData)
            setLoader(false);
        }
        catch (error) {
          console.error('Error occurred while fetching the URL:', error.message);
          setLoader(false);
        }
      }
      else
      {
        const documentUrl = getEsignDocumentUrl(selectedDoc?.pdf_path);
        if (!documentUrl) {
          setLoader(false);
          console.error("Document URL not found in response.");
          return;
        }
        const checkResponse = await fetch(documentUrl, { method: 'GET' });
        if (!checkResponse.ok) {
          setLoader(false);
          console.error(`Document not found: ${documentUrl}`);
          return;
        }
        var previewDocumnetData = {document_url: documentUrl, document_name: selectedDoc?.document_name};
        setPreviewDocument(true);
        setPreviewDoc(previewDocumnetData);
        setLoader(false);
      }
    }
    else
    {
      if(selectedDoc?.document_id)
      {
        setLoader(true)
        try {
          const newTokenData = await dispatch(fetchPdfEditorDetails(profileData.username)).unwrap();      
          const accessToken = newTokenData?.access || pdfEditortoken?.access;
          if (!accessToken) {
            setLoader(false)
            throw new Error("No access token available.");
          }
          const response = await pdfToolApi.getSelectedDocuments(accessToken, selectedDoc?.document_id, selectedDoc.request_id );
          console.log(response)
          if (response.status) {
            const documentUrl = getPdfEditorDocumentUrl(response?.data);
  
            if (!documentUrl) {
                setLoader(false)
                toast.info(`Not Found: document url not found`);
                return;
            }
            const checkResponse = await fetch(documentUrl, { method: 'GET' });
            if (!checkResponse.ok) {
                setLoader(false)
                toast.info(`Not Found: document url not found`);
                return;
            }
            var previewDocumnetData = {document_url: documentUrl, document_name: response?.data?.document_name}
            setPreviewDocument(true);
            setPreviewDoc(previewDocumnetData);
            setLoader(false);
          }
          else{
            setLoader(false);
            toast.info(response?.message);
          }
        } catch (error) {
          setLoader(false)
          if (error.response?.status === 401 && error.response?.data?.code === "token_not_valid") {
            console.warn("Access token expired, attempting to refresh...");
          } else {
            console.error("Error fetching documents:", error);
          }
        } 
      }
    }
  };

  
  const handleDownload = async (doc) => {
    logEvent('Clicked', 'Download Button Clicked', 'Documents');
    if(doc?.pdf_path)
    {
      if(doc?.is_uploaded_to_s3)
      {
        setLoader(true);
        const payload = {
          "file_name": `${doc?.pdf_path}`
        };
        try {
          const response = await fetch(`${apiEndpoint.esignBaseUri}/EsignServices/download_pdf_file_from_s3`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });

          if (!response.ok) {
            setLoader(false);
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
      
          const data = await response.json();
          console.log(data)
          const URLdata = getEsignDocumentUrl(data.url);
          var responsefile = await fetch(URLdata);
          if (!responsefile.ok) {
            setLoader(false);
            throw new Error(`Failed to fetch file: ${responsefile.statusText}`);
          }

          const blob = await responsefile.blob();
          const a = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          var fileName = "pdfForEsign_signedFinal";
          const file_extension = "pdf"
          a.download = fileName + '.' + file_extension;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          setLoader(false);

        } catch (error) {
          console.error('Error occurred while fetching the URL:', error.message);
          setLoader(false);
        }
      }
      else
      {
        setLoader(true);
        let URLdata = getEsignDocumentUrl(doc?.pdf_path);
        var responsefile = await fetch(URLdata);
        if (!responsefile.ok) {
          setLoader(false);
          throw new Error(`Failed to fetch file: ${responsefile.statusText}`);
        }

        const blob = await responsefile.blob();
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        var fileName = doc?.document_name;
        const file_extension = "pdf"
        a.download = fileName + '.' + file_extension;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        setLoader(false);
      }
    }
  };

  const fetchSearchResults = async (searchText, page) => {
    if (searchText.length <= 3) {
      try {
        var data = {
          "status":"",
          "document_name": searchText,
          page,
          limit: rowsPerPage,
        }
        const response = await esignToolApi.searchDocument(data);
        if (response?.status) {
          setDocuments(response.data);
          setTotalPages(response.pages);
        }
      } catch (error) {
        setLoader(false);
        console.error("Error searching data:", error);
      }
    }
  };
  
  // Debounce function to optimize API calls
  const debouncedSearch = debounce((value) => {
    if(value) {
      fetchAllDocuments(currentPage, rowsPerPage, value);
      setCurrentPage(1);
    }
    else
    {
      fetchAllDocuments(currentPage, rowsPerPage, "");
      setCurrentPage(1);
    }
  }, 700);
  
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchText(value);
    debouncedSearch(value);
  };

  // const filteredDocs = documents.filter((doc) =>
  //     doc.document_name.toLowerCase().includes(searchText.toLowerCase())
  // );

  const handleDocumentDetails = async (row) =>
  {
    logEvent('Table Row Clicked', 'Document Details', 'Documents');
    setLoader(true)
    try {
      const response = await esignToolApi.getAllSignerStatus(row?.document_id, row?.request_id);
      setLoader(false)
      console.log(response)
      if (response) {
        setOpenDetails(true)
        setSelectedDetailDoc(row)
        setSignersStatus(response?.data)
      }
    } catch (error) {
      setLoader(false)
      console.error("Error fetching data:", error);
    }
  }

  const handleStatusChange = (event, newStatus) => {
    if (newStatus !== null) setStatus(newStatus);
  };
  
  return (
    <>
      {!openDetails && (
        <>
          <Box sx={{ display: "flex", padding: "0px 30px", justifyContent: "space-between", alignItems: "center" }}>
            <TextField
              placeholder="Search..."
              type="text"
              variant="outlined"
              onChange={handleSearchChange}
              sx={{
              boxSizing: "border-box",
              borderRadius: "10px",
              backgroundColor: "#fff",
              borderColor: "#E8E8E9",
              borderWidth: "5px",
              "& .MuiOutlinedInput-root": {
                  borderColor: "#E8E8E9",
                  backgroundColor: "none",
                  "&:hover fieldset": {
                  borderColor: "#E8E8E9",
                  },
                  "&.Mui-focused fieldset": {
                  borderColor: "#E8E8E9",
                  },
              },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {esignIcons.searchIcon}
                  </InputAdornment>
                ),
                sx: { 
                  borderRadius: "10px",
                  width: 410,
                  height: 40,
                  fontSize: "16px",
                  fontWeight: "500",
                  "& input::-ms-reveal, & input::-ms-clear": {
                      display: "none",
                  },
                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                      display: "none",
                      WebkitAppearance: "none",
                      margin: 0,
                  },
                  "& input[type=number]": {
                      MozAppearance: "textfield",
                  },
                },
              }}
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
              <Button variant="contained" sx={{ minWidth: 115, height: 40, background: "#FFFFFF", color: "#1D1D1D", borderRadius: "8px", border: "1px solid #E8E8E9", boxShadow: "none", p:0, display: "flex", alignItems: "center", gap: "12px", textTransform: "capitalize", fontSize: "14px", fontWeight: "400" }} onClick={() => {fetchAllDocuments(currentPage, rowsPerPage, searchText );}} >
                {esignIcons.refreshIcon} Refresh
              </Button>
              {/* <Button variant="contained" sx={{ minWidth: 115, height: 40, background: "#FFFFFF", color: "#1D1D1D", borderRadius: "8px", border: "1px solid #E8E8E9", boxShadow: "none", p:0, display: "flex", alignItems: "center", gap: "12px", textTransform: "capitalize", fontSize: "14px", fontWeight: "400" }} onClick={() => {setFilter(true);}} >
                {esignIcons.filterIcon} Filters
              </Button> */}
            </Box>
          </Box>
          <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none", height: "90%", mt: "15px" }}>
            <TableContainer sx={{ maxHeight: "89%" }}>
              <Table stickyHeader>
                <TableHead sx={{ background: "#F5F5F5", fontSize: "15px", fontWeight: 500, color: "#1D1D1D" }}>
                  <TableRow>
                    <TableCell sx={{  pl: "30px", }}>S. No.</TableCell>
                    <TableCell>Document Name</TableCell>
                    <TableCell>Created On</TableCell>
                    <TableCell>Signers</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableloader ? (
                    [...Array(rowsPerPage)].map((_, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ pl: "30px" }}>
                          <Skeleton variant="text" width={30} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={180} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={120} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={80} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width={80} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="circular" width={30} height={30} />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : documents.length > 0 ? (
                    documents.map((row, index) => (
                        <TableRow key={row.request_id} onClick={() => handleDocumentDetails(row)} sx={{
                          "&:hover": { backgroundColor: "#fafafa",}
                        }}>
                          <TableCell sx={{ pl: "30px", cursor: "pointer" }}>{((currentPage - 1) * rowsPerPage + index + 1).toString().padStart(2, "0")}</TableCell>
                          <TableCell sx={{ cursor: "pointer" }}>{row?.document_name?.length > 30 ? row?.document_name.slice(0, 30) + "..." : row?.document_name}</TableCell>
                          <TableCell sx={{ cursor: "pointer" }}>
                            {new Date(row.created_at).toLocaleString()}
                          </TableCell>
                          <TableCell sx={{ cursor: "pointer",}}>
                            <Box sx={{ display: "flex", alignItems: "center", gap:1 }}>
                              {esignIcons.signersIcon}{`${(row?.COMPLETED || 0).toString().padStart(2, "0")}/${((row?.PENDING || 0) + (row?.COMPLETED || 0) + (row?.EXPIRED || 0)).toString().padStart(2, "0")}`}
                            </Box>
                          </TableCell>
                          <TableCell sx={{ color: getStatusStyles(row.status).color, cursor: "pointer", textTransform: "capitalize" }}>{row.status}</TableCell>
                          <TableCell onClick={(e) => e.stopPropagation()} >
                            <IconButton
                              onClick={() => {
                                setSelectedDoc(null);
                                setTimeout(() => setSelectedDoc(row), 0);
                              }}
                            >
                              {esignIcons.eyeIcon}
                            </IconButton>
                            <IconButton disabled={row?.status?.toLowerCase() === "expired"}
                              onClick={() => handleDownload(row)}
                            >
                              {esignIcons.downloadIcon}
                            </IconButton>
                            <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                            {esignIcons.moreIcon}
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No documents found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 20, 30, 50]}
              component="div"
              count={totalEntries}
              rowsPerPage={rowsPerPage}
              page={currentPage - 1}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                position: "sticky",
                bottom: 0,
                backgroundColor: "white",
                zIndex: 2,
              }}
            />
          </Paper>

          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
                sx: {
                    height: "42px",
                    width: "168px",
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-evenly",
                    overflow: "hidden",
                    alignItems: "center",
                },
            }}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "center", 
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
          >
            {/* <MenuItem onClick={handleNewRequest} sx={{ fontSize: "14px", fontWeight: "400", color: "#5C5C5C", gap: 1, pt:"3px", }} disabled={selectedDoc?.status.toLowerCase() !== "completed"}>{esignIcons.editIcon} New Request</MenuItem> */}
            <MenuItem onClick={handleNewRequest} sx={{ fontSize: "14px", fontWeight: "400", color: "#5C5C5C", gap: 1, pt:"3px", }} disabled={!["completed", "expired"].includes(selectedDoc?.status?.toLowerCase())}>{esignIcons.editIcon} New Request</MenuItem>
          </Menu>

          <Modal open={filter}>
            <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "500px", backgroundColor: "#fff", boxShadow: 24, overflow: "hidden", borderRadius: "20px", }}>
              <Box sx={{ padding: "25px 30px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="p" sx={{fontSize: "22px", fontWeight: 600, color: "#1D1D1D", }}>Filters</Typography>
                <Typography variant="p" sx={{fontSize: "18px", fontWeight: 500, color: "#185CB7", }}>Clear Filter</Typography>
              </Box>
              <Divider />
              <Box sx={{ padding: "25px 30px 0 30px", }}>
                  <Typography variant="p" sx={{ fontSize: "18px", fontWeight: 500, color: "#1D1D1D", }}>Select your date range</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs} >
                    <Box sx={{ display: 'flex', gap: 2, mt: "22px" }}>
                      <DatePicker
                        sx={{ width: "100%", height: 46, 
                          '& .MuiInputBase-root': {
                            height: 46,
                          },
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                              border: "1px solid #DFD8D8 !important",
                          },
                          "& .Mui-error .MuiOutlinedInput-notchedOutline": {
                              border: "1px solid #DFD8D8 !important",
                          }, 
                        }}
                        format="DD/MM/YYYY"
                        value={startDate}
                        onChange={setStartDate}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            placeholder: 'dd/mm/yyyy',
                          }
                        }}
                      />
                      <DatePicker
                        sx={{ width: "100%", height: 46, 
                          '& .MuiInputBase-root': {
                            height: 46,
                          },
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                              border: "1px solid #DFD8D8 !important",
                          },
                          "& .Mui-error .MuiOutlinedInput-notchedOutline": {
                              border: "1px solid #DFD8D8 !important",
                          }, 
                        }}
                        format="DD/MM/YYYY"
                        value={endDate}
                        onChange={setEndDate}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            placeholder: 'dd/mm/yyyy',
                          }
                        }}
                      />
                    </Box>
                  </LocalizationProvider>
              </Box>
              <Box sx={{ padding: "25px 30px", }}>
                  <Typography variant="p" sx={{ fontSize: "18px", fontWeight: 500, color: "#1D1D1D", }}>Status</Typography>
                  <ToggleButtonGroup
                    value={status}
                    exclusive
                    onChange={handleStatusChange}
                    sx={{ display: 'flex', gap: 2, mt: "22px" }}
                  >
                    <ToggleButton value="all" sx={toggleStyle(status === 'all')}>All</ToggleButton>
                    <ToggleButton value="expired" sx={toggleStyle(status === 'expired')}>Expired</ToggleButton>
                    <ToggleButton value="completed" sx={toggleStyle(status === 'completed')}>Completed</ToggleButton>
                  </ToggleButtonGroup>
              </Box>
              <Divider />              
              <Box sx={{ display: "flex", justifyContent: "end", p: "15px 30px", gap: "20px", }}>
                  <Button variant="contained" sx={{ width: '120px', height: 46, color: "#1D1D1D", background: "#ffffff", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500", }} onClick={() => { setFilter(false);}}  >
                      Cancel
                  </Button>
                  <Button variant="contained" sx={{ width: '120px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", }} onClick={() => { setFilter(false);}}  >
                    Apply
                  </Button>
              </Box>
            </Box>
          </Modal>
        </>
      )}
      {openDetails && <DocumentDetails doc={selectedDetailDoc} setSelectedDetailDoc={setSelectedDetailDoc} setOpenDetails={setOpenDetails} openDetails={openDetails} signersStatus={signersStatus} handleDocumentDetails={handleDocumentDetails} />}
      {loader && <Loader />}
      {previewDocument && <PdfPreview previewDoc={previewDoc} setPreviewDoc={setPreviewDoc} previewDocument={previewDocument} setPreviewDocument={setPreviewDocument} />}
      
      </>
  );
};
const toggleStyle = (selected) => ({
  borderRadius: "10px !important",
  textTransform: "none",
  fontSize: "16px",
  fontWeight: "500",
  color: selected ? "#185CB7" : "#1D1D1D",
  backgroundColor: selected ? "#E6F1FF !important" : "#ffffff !important",
  border: selected ? "1px solid #CCE2FE !important" : "1px solid #D2D2D2 !important",
  minWidth: "70px",
  height: "46px",
  boxShadow: "none",
  '&.Mui-selected': {
    backgroundColor: "#E6F1FF",
    color: "#185CB7",
    border: "1px solid #CCE2FE",
  },
  '&:hover': {
    backgroundColor: "#E6F1FF",
  }
});

export default AllDocumentTable;
